// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__6KPze","left":"InfoRow_left__2PIsJ"};